import { FEEDBACK_URL } from '@/config/constants.ts'
import { testIdFactory } from '@/utils/test-id-factory.ts'

const FeedbackButton = () => {
	return (
		<a
			className="fixed bottom-36 right-0 bg-danger text-white text-[1.5rem] leading-[26px] z-50 px-6 py-2 rounded-3xl rounded-bl-none rounded-br-none uppercase m-0 translate-x-[calc(50%-1.25rem)] -rotate-90"
			target="_blank"
			href={FEEDBACK_URL}
			data-testid={testIdFactory.navigationFeedbackButton()}
		>
			Feedback
		</a>
	)
}

export default FeedbackButton
